// Port of api/fuel/app/classes/insights/plays/designer.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'designer',
    insight: false,
    default_: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        var games = []
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        var played = Util.queryFast(
            'SELECT g.game_id AS g, SUM(p.play_count) AS c' +
            ' FROM game_designer gp, play p, game g' +
            ' WHERE gp.designer_id = ' + vars.id +
            ' AND p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date < ' + range.end +
            ' AND gp.game_id = g.game_id' +
            ' AND p.game_id = g.game_id' +
            ' AND g.game_type = 1' +
            sqlCount +
            ' GROUP BY p.game_id' +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC',
            null, 'g'
        )

        var playedIndex = Object.keys(played).map(function(k) { return played[k].g })

        if (!playedIndex.length) playedIndex = [0]

        var ratings = Util.queryFast(
            'SELECT COUNT(r.rating_id) AS c, AVG(r.rating_value) AS a, r.game_id AS g' +
            ' FROM rating r' +
            ' WHERE r.game_id IN(' + Util.in(playedIndex) + ')' +
            ' AND r.user_id IN(' + Util.in(userIndex) + ')' +
            ' GROUP BY r.game_id',
            null, 'g'
        )

        var count = 0

        for (var i = 0; i < playedIndex.length; i++) {
            var game_id = playedIndex[i]
            if (!played[game_id]) continue

            this._references.games.push(game_id)

            games.push({
                id: game_id,
                plays: parseInt(played[game_id].c, 10),
                count: ratings[game_id] ? parseFloat(ratings[game_id].c) : 0,
                rating: ratings[game_id] ? Math.round(parseFloat(ratings[game_id].a) * 10) / 10 : 0
            })

            count += parseInt(played[game_id].c, 10)
        }

        var designerRow = Util.queryFast(
            'SELECT designer_name FROM designer WHERE designer_id = ' + vars.id
        )
        var designerName = designerRow.length ? designerRow[0].designer_name : ''

        return {
            count: count,
            designer: designerName,
            games: games
        }

    }
})
